import { j as e } from "./atoms-v218.js";
import { FloatingFooterWrapper as P, Center as F, PriceInfoWrapper as g, RoomName as C, PriceInfoBottom as b, PriceTextFloatingFooter as S, PaymentButtonWrapper as B, FooterButton as h, Right as R, FooterText as j, Wrapper as T, UpperSection as W, LeftSection as _, PriceText as v, RightSection as A } from "./atoms-v21028.js";
import { Link as a } from "./atoms-v224.js";
import { PaymentButton as u } from "./atoms-v21029.js";
import { useBreakpoints as I } from "./atoms-v251.js";
function d(s) {
  return "brand" in s;
}
const q = ({
  className: s,
  colorTheme: t = "light",
  currency_code: c,
  floatingFooterRoomName: p,
  footer: l,
  footerButtons: i,
  isFloatingFooter: f = !1,
  language: x,
  priceBreakdownLink: o,
  totalAddonPrice: m = 0
}) => {
  const { current: $ } = I(), y = !["small", "medium"].includes($);
  return /* @__PURE__ */ e.jsx(e.Fragment, { children: y && f ? /* @__PURE__ */ e.jsxs(P, { $colorTheme: t, children: [
    /* @__PURE__ */ e.jsxs(F, { children: [
      /* @__PURE__ */ e.jsxs(g, { children: [
        /* @__PURE__ */ e.jsx(C, { $colorTheme: t, children: p }),
        /* @__PURE__ */ e.jsxs(b, { children: [
          /* @__PURE__ */ e.jsx(S, { $colorTheme: t, children: (o.total_after_discount + m).toLocaleString(x, {
            currency: c,
            style: "currency"
          }) }),
          /* @__PURE__ */ e.jsx(a, { renderAsButton: !0, onClick: o.onPriceBreakdownClick, children: o.label })
        ] })
      ] }),
      /* @__PURE__ */ e.jsx(B, { $isAloneButton: i.length === 1, children: i.map(
        (r, n) => d(r) ? /* @__PURE__ */ e.jsx(u, { ...r }, `footer-button-${n}`) : /* @__PURE__ */ e.jsx(h, { ...r }, `footer-button-${n}`)
      ) })
    ] }),
    /* @__PURE__ */ e.jsx(R, { children: /* @__PURE__ */ e.jsx(j, { $colorTheme: t, children: l }) })
  ] }) : /* @__PURE__ */ e.jsxs(T, { $colorTheme: t, className: s, children: [
    /* @__PURE__ */ e.jsxs(W, { children: [
      /* @__PURE__ */ e.jsxs(_, { children: [
        /* @__PURE__ */ e.jsx(a, { renderAsButton: !0, onClick: o.onPriceBreakdownClick, children: o.label }),
        /* @__PURE__ */ e.jsx(v, { type: "body", variant: "compact-expressive", children: (o.total_after_discount + m).toLocaleString(x, {
          currency: c,
          style: "currency"
        }) })
      ] }),
      /* @__PURE__ */ e.jsx(A, { children: i.map(
        (r, n) => d(r) ? /* @__PURE__ */ e.jsx(u, { ...r }, `footer-button-${n}`) : /* @__PURE__ */ e.jsx(h, { ...r }, `footer-button-${n}`)
      ) })
    ] }),
    /* @__PURE__ */ e.jsx(j, { $colorTheme: t, children: l })
  ] }) });
};
export {
  q as CheckoutFooter
};
